import React from 'react'
import { FaBars, FaTimes } from 'react-icons/fa'
import { useState } from 'react'
import { Link } from "react-scroll"; 



const NavBar = () => {

  const [nav, setNav] = useState(false)

  const links = [
    {
      id: 1,
      link: 'Home',
      style : "text-white px-4 py-2 rounded transition-colors hover:bg-gray-600 hover:text-gray-200 "
    },
    {
      id: 2,
      link: 'About'
    },
    {
      id: 3,
      link: 'Portfolio'
    },
    {
      id: 4,
      link: 'Experience'
    },
    {
      id: 5,
      link: 'Contact'
    },
  ];
  
    return (
    <div className='flex justify-between items-center w-full  h-20
    text-white fixed bg-black' >
      <div>
        <h1 className='text-center ml-2  font-bold hover:divide-sky-200 text-gray-700 transition-transform transform hover:scale-110 cursor-pointer'>WELCOME!!</h1>
      </div>

      <ul className="hidden md:flex">

        {links.map(({ id, link }) => (
          
          <li key={id}
           className="px-4 cursor-pointer capitalize font-medium
          text-gray-500 hover:scale-150 hover:text-blue-600 duration-200">
          
          <Link to={link.toLowerCase()}  smooth duration={550}>
                {link}
              </Link>
      
        </li>


        ))}


      </ul>


      <div onClick={() => setNav(!nav)} className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden" >
        {nav ? <FaTimes size={40} /> : <FaBars size={40} />}

      </div>

      {nav && (
        <ul className='flex flex-col justify-center 
                items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b
                from-black to-gray-800 text-gray-500'>

          {links.map(({ id, link }) => (
            <li key={id} className="px-4 cursor-pointer capitalize py-6 text-4xl">
              
          <Link onClick={() => setNav(!nav)} to={link.toLowerCase()}  smooth duration={550}>
                {link}
              </Link>
            </li>


          ))}
        </ul>

      )}


    </div>
  )
}

export default NavBar
